<template>
    <div id="specialLegalText">
        <component :is="getLocalizedLegalText" ref="specialLegalText"></component>
    </div>
</template>

<script>
import { useGlobal } from "../../stores/globalStore.js"
import { mapState } from "pinia"

import defaultComp from "./default.vue"
import auComp from "./au.vue"
import sgComp from "./sg.vue"

export default {
    data: () => ({
        currentComp: null
    }),

    computed: {

        ...mapState(useGlobal, ["country"]),

        getLocalizedLegalText() {
            if (this.country == "AU") {return auComp}
            else if (this.country == "SG") {return sgComp}
            else {return defaultComp}
        }
    },

    components: {
        defaultComp,
        auComp,
        sgComp
    },

    methods: {
        accept() {
            return this.$refs.specialLegalText.accept()

        }
    }
}
</script>

<style lang="css">

#specialLegalText > patternlib-modal {
    position: absolute;
    z-index: 200;
}

</style>